'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-sync/node_modules/core-js/internals/is-pure.js
// module id = 356
// module chunks = 25